<template>
    <ion-page class="ion-page" id="main">
        <default-header :title="$t('ncrypt.header_title')"></default-header>

        <ion-content fullscreen>
            <div v-if="!loading && !error && message">
                <ion-item>
                    <ion-text color="dark">
                        <h5>{{ $t('ncrypt.verify_open_message.your_received_message') }}</h5>
                    </ion-text>
                </ion-item>
                <message-with-logic :message="message" :recipient-viewer="recipient"></message-with-logic>
            </div>
            <div v-if="error">
                <ion-card class="floating">
                    <ion-card-header>
                        <ion-card-title>{{ errorSubject }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <p v-html="errorMessage"/>
                    </ion-card-content>
                </ion-card>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
    import {ApiError} from "../errors/ApiError";
    import {ErrorHandler} from "../services/ErrorHandler";
    import DefaultHeader from "./nav/DefaultHeader.vue";

    export default {
        components: {
            MessageWithLogic: () => import("./messages/MessageWithLogic"),
            DefaultHeader,
        },
        data() {
            return {
                loading: true,
                error: false,
                errorSubject: this.$t('ncrypt.errors.alert_default_title'),
                errorMessage: null,
                message: undefined,
                recipient: undefined,
            }
        },
        methods: {
            validateOpenMessage() {
                return new Promise((resolve, reject) => {
                    this.$http
                        .post(`/m/${this.$route.params.access_token}/validate-token`, {
                            token: this.$route.params.email_token,
                        })
                        .then(async ({data}) => {
                            if (data && !data.success) {
                                if (data.can_use_code) {
                                    data = this.$t('ncrypt.errors.open_message_verification_failed_possibly_switched_internet_browser');
                                }
                                return reject(data, false);
                            }

                            if (data.authed_access) {
                                if (this.loading && this.loader) {
                                    await this.loader.dismiss();
                                }

                                await this.$store.dispatch('refreshUser');

                                await this.$router.push({name: 'message', params: {id: data.message_id}});
                                return;
                            }

                            if (data.wrong_user) {
                                await this.$store.dispatch('refreshUser');
                            }

                            this.recipient = data.recipient;

                            resolve(data.message);
                        })
                        .catch(error => reject(error, true));
                });
            },
        },
        async created() {
            this.loader = await this.$ionic.loadingController.create({duration: 10000});

            await this.loader.present();

            this.validateOpenMessage()
                .then(async (message) => this.message = message)
                .catch((error, shouldLogError) => {
                    this.error = true;
                    if (error.subject) {
                        this.errorSubject = error.subject;
                    }
                    this.errorMessage = ErrorHandler.buildApiErrorMessage(error);
                    if (shouldLogError) {
                        new ApiError(this.errorMessage, true);
                    }
                })
                .finally(async () => {
                    await this.loader.dismiss();
                    this.loading = false;
                })
                .catch(() => {
                    //
                });
        }
    }
</script>
